// @ts-nocheck


import styled from 'styled-components';

export const SectionContent = styled.div.withConfig({ displayName: "elements__SectionContent", componentId: "sc-19zud0x-0" })(["padding:16px;overflow-x:auto;"]);




export const WarningCellElement = styled.div.withConfig({ displayName: "elements__WarningCellElement", componentId: "sc-19zud0x-1" })(["color:red;background:#ffa39e;width:100%;height:100%;display:flex;align-items:center;text-align:center;justify-content:center;"]);
